import "babel-polyfill";
import browserDetect from "vue-browser-detect-plugin";
import axios from "axios";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// import { Auth0Plugin } from "./auth";
import hljs from "highlight.js/lib/core";
import "highlight.js/styles/github.css";

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.api = "https://www.kmppartners.info:1136/api-tor";
// Vue.prototype.api = "http://192.168.10.38:1136/api-tor";
Vue.prototype.version = "KMP Partners TOR 66.07.13.01";

Vue.use(hljs.vuePlugin);
Vue.use(browserDetect);
// Vue.use(Auth0Plugin, {
//   domain,
//   clientId,
//   onRedirectCallback: appState => {
//     router.push(
//       appState && appState.targetUrl
//         ? appState.targetUrl
//         : window.location.pathname
//     );
//   }
// });

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
